import PropTypes from 'prop-types';
import React from 'react';

import SearchResultsArticle from './search-results-article';

class SearchResults extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.renderArticle = this.renderArticle.bind(this);
  }

  renderArticle(article, index) {
    const { id } = article;
    const { query } = this.props;
    const position = index + 1;
    const currentPage = this.props.page + 1;

    return (
      <li key={id} className="search-results-article-container">
        <SearchResultsArticle
          id={id}
          data={article}
          query={query}
          position={position}
          currentPage={currentPage}
        />
      </li>
    );
  }

  render() {
    const { hits } = this.props;

    return (
      <div className="search-results">
        <ul className="search-results-article-list">
          {hits.map(this.renderArticle)}
        </ul>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
SearchResults.propTypes = {
  hits: PropTypes.array,
  query: PropTypes.string,
  page: PropTypes.number,
};

export default SearchResults;
